import Text from "common/Typography/Text";
import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

interface ConfigurationItemProps {
  title: ReactNode;
  value: ReactNode;
}

const ConfigurationItem = ({ title, value }: ConfigurationItemProps) => {
  return (
    <ItemWrapper>
      <ItemTitle>{title}</ItemTitle>
      <ItemValue>{value}</ItemValue>
    </ItemWrapper>
  );
};

export default ConfigurationItem;

const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 12px;
  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      align-items: baseline;
      column-gap: 16px;
      padding: 8px 0;
      &:not(:last-of-type) {
        margin-bottom: 0;
      }
    `}
`;
const ItemTitle = styled(Text).attrs({ type: "secondary", as: "div" })`
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        flex: none;
        max-width: 50%;
        ${newLookType.label};
        color: ${getNewLookTokens(p.theme).secondary};
      }
    `}
`;
const ItemValue = styled(Text).attrs({ as: "div" })`
  font-weight: 500;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      && {
        min-width: 0;
        color: ${getNewLookTokens(p.theme).ink};
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        font-variant-numeric: tabular-nums;
        text-align: right;
      }
    `}
`;
